<template>
  <div class="home">
    <b-container>
      <b-row class="bg-dkblue header">
      </b-row>
    </b-container>

    <img class="logo-welcome" id="logo" alt="logo" src="../assets/logos/mdcai_logo_white_v1.svg"><br />


Your e-mail address has been whitelisted.<br />
Please complete the form to continue registration.<br /><br />

<b-container>

  <validation-observer ref="observer" v-slot="{ handleSubmit }">

    <b-form @submit.stop.prevent="handleSubmit(onSubmit)" @reset="onReset">
      <b-row align-h="center">

        <b-col cols="7">

          <b-row class="text-left">
            <b-col cols="4" align-h="left" text-align="left">
              E-mail:
            </b-col>
            <b-col cols="8" align-h="left">
              {{ form.email }}
            </b-col>
          </b-row>
          <br />

        <!--<b-form-group label="Email:" label-for="email" label-align="left" label-cols="4" content-cols="8">
          <b-form-input v-model="form.email" :disabled="true" type="email"></b-form-input> 
        </b-form-group>-->

        <validation-provider name="firstname" rules="required|alpha_spaces|min:3" v-slot="validationContext">
          <b-form-group id="firstname_group1" label="First Name:" label-for="firstname_input1" label-align="left" label-cols="4" content-cols="8">
            <b-form-input placeholder="First Name" id="firstname_input1" name="firstname_input1" v-model="form.firstname" :state="getValidationState(validationContext)" aria-describedby="firstname_feedback">
            </b-form-input>
            <!--<b-form-invalid-feedback id="firstname_feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>-->
            <b-form-invalid-feedback id="firstname_feedback">First Name is required.</b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <validation-provider name="lastname" rules="required|alpha_spaces|min:3" v-slot="validationContext">
          <b-form-group id="lastname_group1" label="Last Name:" label-for="lastname_input1" label-align="left" label-cols="4" content-cols="8">
            <b-form-input placeholder="Last Name" id="lastname_input1" name="lastname_input1" v-model="form.lastname" :state="getValidationState(validationContext)" aria-describedby="lastname_feedback">
            </b-form-input>
            <b-form-invalid-feedback id="lastname_feedback">Last Name is required.</b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <validation-provider name="password" :rules="{ required: true, min: 8, password: true }" v-slot="validationContext">
          <b-form-group id="password_group1" label="Password:" label-for="password_input1" label-align="left" label-cols="4" content-cols="8">
            <b-form-input placeholder="Password" type="password" id="password_input1" name="password_input1" v-model="form.password" :state="getValidationState(validationContext)" aria-describedby="password_feedback">
            </b-form-input>
            <b-form-invalid-feedback id="password_feedback">Password must be at least 8 characters, and contain one upper case letter, lower case letter, number, and symbol.</b-form-invalid-feedback>

          </b-form-group>
        </validation-provider>

        <validation-provider name="confirm_password" rules="required|confirmed:password" v-slot="validationContext">
          <b-form-group id="confirm_password_group1" label="Confirm Password:" label-for="confirm_password_input1" label-align="left" label-cols="4" content-cols="8">
            <b-form-input placeholder="Confirm Password" type="password" id="confirm_password_input1" name="confirm_password_input1" v-model="form.confirm_password" :state="getValidationState(validationContext)" aria-describedby="confirm_password_feedback">
            </b-form-input>
            <b-form-invalid-feedback id="confirm_password_feedback">Passwords do not match.</b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>


        </b-col>
      </b-row>

      <br />

      <b-button type="submit" squared class="btn-welcome">Submit</b-button>&nbsp;
      <b-button type="reset" squared class="btn-welcome">Reset</b-button>
    </b-form>

  </validation-observer>

</b-container>

  </div>
</template>





<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import { Validator, ValidationObserver, ValidationProvider, extend, localize } from "vee-validate";

import en from "vee-validate/dist/locale/en.json";
import * as rules from "vee-validate/dist/rules";


extend("password", {
  getMessage: (field) =>
    "The " +
    field +
    " value must contain 1 uppercase, 1 lowercase, 1 number, and 1 special character.",
  validate: (value) => {
    return (
      /[A-Z]/.test(value) &&
      /[a-z]/.test(value) &&
      /\d/.test(value) &&
      /[!@#$%^&*()_\-+=`~<>?\\/;,.'"\][{}]/.test(value)
    );
  }
});

// Install VeeValidate rules and localization
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

localize("en", en);


export default {
  name: 'registerAllowed',
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      form: {
        email: this.$store.state.register.email,
        firstname: null,
        lastname: null,
        password: null,
        confirm_password: null
      }
    };
  },

  mounted() {
    this.$store.state.loadingOverlay = false
  },

  methods: {

    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },

    onSubmit() {
      
      this.$store.state.loadingOverlay = true

      const axios = require('axios')
      var url = this.$store.state.locals.apiUrl + '/registerUser'

      var email = this.form.email.toLowerCase()
      var data = JSON.stringify(this.form)


      var config = {
        method: 'post',
        url: url,
        headers: { 
          'api-key': this.$apikey, 
          'Content-Type': 'application/json'
        },
        data : data
      };

      axios(config)
      .then((response) => {
        var status = response.data.status

        // registration successful
        if (status == "success") {
          this.$router.push('registerComplete')

        // registration unsuccessful
        } else {
          this.$store.state.error = status;
          this.$router.push('error')
        }

      })
      .catch((error) => {
        console.log(error);
        this.$store.state.error = error;
        this.$router.push('error')
      });

    },

      onReset(event) {
        // Reset our form values
        this.form.firstname = ''
        this.form.lastname = ''
        this.form.password = ''
        this.form.confirm_password = ''
      }
  }
};
</script>
